import axios, { InternalAxiosRequestConfig } from "axios";
import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { FluxoType } from "../../stores/tenant/tenant.types";

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((request) => {
  const { type } = useTenantStore.getState();

  applyDefaultHeaders(request);

  if (type === FluxoType.CONSULTOR) applyParceiroEnvironmentHeaders(request);
  else applyClienteEnvironmentHeaders(request);
  return request;
});

const applyDefaultHeaders = (request: InternalAxiosRequestConfig) => {
  const { partnerId, partner } = useTenantStore.getState();
  if (partner && "id" in partner) request.headers["Ivi-Parceiro-Id"] = partnerId;
  if (partner && "fluxo" in partner && "id" in partner.fluxo) request.headers["Ivi-Fluxo-Id"] = partner.fluxo.id;
};

const applyClienteEnvironmentHeaders = (request: InternalAxiosRequestConfig) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    request.headers.Authorization = token;
  }
};

const applyParceiroEnvironmentHeaders = (request: InternalAxiosRequestConfig) => {
  const contactEmail = sessionStorage.getItem("contactEmail");
  if (contactEmail) {
    request.headers["Ivi-User-Email"] = contactEmail;
  }
};
